import { combineReducers } from 'redux';
import {
  UPLOAD_TRIAL_BALANCE_FILE,
} from '../trialBalanceTab/store/types';

import {
  FETCH_PROVISION_DATA_SUCCESS,
  FETCH_COMPANY_CODE_DETAILS_SUCCESS,
  FETCH_COMPANY_CODE_DETAILS_FAILURE,
} from '../../shared/store/types';

import {
  CALCULATE_PROVISION,
  CALCULATE_PROVISION_SUCCESS,
  CALCULATE_PROVISION_FAILURE,
  UPLOAD_TRIAL_BALANCE_FILE_FAILURE,
  UPLOAD_TRIAL_BALANCE_FILE_SUCCESS,
  PROFORMA_CALC,
  DOWNLOAD_PROVISION_DETAILS,
  DOWNLOAD_PROVISION_DETAILS_SUCCESS,
  DOWNLOAD_PROVISION_DETAILS_FAILURE,
} from './types';

import trialBalanceReducer from '../trialBalanceTab/store/reducer';
import journalTableReducer from '../journalTab/store/reducer';
import adjustmentsReducer from '../adjustmentsTab/store/reducer';
import batchProvisionsReducer from '../batchProvisionsPage/store/reducer';
import batchAdjustmentsReducer from '../batchAdjustmentsPage/store/reducer';

import { LOGOUT_SUCCESS } from '../../userData/store/types';

import initialState from './initialState';

function provisionReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROVISION_DATA_SUCCESS:
    case CALCULATE_PROVISION_SUCCESS:
      return {
        ...state,
        ...action.provisionData.general,
        countryTaxTypes: action.provisionData.countryTaxTypes || [],
        adjustmentTypes: action.provisionData.adjustmentTypes || [],
        companyCodeDetails: action.provisionData.companyCodeDetails || {},
        taxRates: action.provisionData.taxRates || [],
        taxAccounting: action.provisionData.taxAccounting || [],
        bookToTaxDifferences: action.provisionData.bookToTaxDifferences || [],
        isCalculatingProvision: false,
        isProformaCalc: false,
        isMultiTaxNonUS: action.provisionData.isMultiTaxNonUS,
        taxExpense: action.provisionData.calcWorkTables,
        journals: action.provisionData.journals,
        localJournals: action.provisionData.localJournals,
        journalsDetail: action.provisionData.journalsDetail,
        calcResultsLog: action.provisionData.calcResultsLog,
      };
    case UPLOAD_TRIAL_BALANCE_FILE_SUCCESS:
      return {
        ...state,
        isUploadingTrialBalance: false,
      };
    case FETCH_COMPANY_CODE_DETAILS_SUCCESS:
      return {
        ...state,
        companyCodeDetails: action.companyCodeDetails || {},
        companyCodeDetailsError: null,
      };
    case FETCH_COMPANY_CODE_DETAILS_FAILURE:
      return {
        ...state,
        companyCodeDetails: {},
        companyCodeDetailsError: action.error,
      };
    case CALCULATE_PROVISION:
      return {
        ...state,
        isCalculatingProvision: true,
      };
    case PROFORMA_CALC:
      return {
        ...state,
        isProformaCalc: true,
      };
    case UPLOAD_TRIAL_BALANCE_FILE:
      return {
        ...state,
        isUploadingTrialBalance: true,
      };
    case CALCULATE_PROVISION_FAILURE:
      return {
        ...state,
        isCalculatingProvision: false,
        isProformaCalc: false,
      };
    case LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    case UPLOAD_TRIAL_BALANCE_FILE_FAILURE:
      return {
        ...state,
        isUploadingTrialBalance: false,
      };
    case DOWNLOAD_PROVISION_DETAILS:
      return {
        ...state,
        isDownloadingProvisionDetails: true,
      };
    case DOWNLOAD_PROVISION_DETAILS_SUCCESS:
      return {
        ...state,
        isDownloadingProvisionDetails: false,
      };
    case DOWNLOAD_PROVISION_DETAILS_FAILURE:
      return {
        ...state,
        isDownloadingProvisionDetails: false,
      };
    default:
      return state;
  }
}

export default combineReducers({
  adjustments: adjustmentsReducer,
  journalTable: journalTableReducer,
  trialBalance: trialBalanceReducer,
  batchProvisions: batchProvisionsReducer,
  batchAdjustments: batchAdjustmentsReducer,
  general: provisionReducer,
});
